export default __webpack_public_path__ + "static/media/sprite.2066a981.svg";